import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    season: '2008',
    venue: 'Dr DY Patil Sports Academy, Mumbai, India',
    fixture:'RR Vs CSK',
    champion:'RR',
    Orange_Cap:'SE Marsh',
    Purple_Cap: 'Sohail Tanvir',
    Man_of_the_Series: 'SR Watson'
  },
  {
    id: uuid(),
    season: '2009',
    venue: 'New Wanderers Stadium, Johannesburg, South Africa',
    fixture: 'DC Vs RCB',
    champion:'DC',
    Orange_Cap:'ML Hayden',
    Purple_Cap: 'RP Singh',
    Man_of_the_Series: 'AC Gilchrist'
  },
  {
    id: uuid(),
    season: '2010',
    venue:'Dr DY Patil Sports Academy, Mumbai, India',
    fixture:'CSK Vs MI',
    champion:'CSK',
    Orange_Cap: 'SR Tendulkar',
    Purple_Cap: 'PP Ojha',
    Man_of_the_Series: 'SR Tendulkar'
  },
  {
    id: uuid(),
    season: '2011',
    venue:'MA Chidambaram Stadium, Chennai, India',
    fixture:'CSK Vs RCB',
    champion:'CSK',
    Orange_Cap: 'CH Gayle',
    Purple_Cap: 'SL Malinga',
    Man_of_the_Series: 'CH Gayle'
  },
  {
    id: uuid(),
    season: '2012',
    venue: 'MA Chidambaram Stadium, Chennai, India',
    fixture:'KKR Vs CSK',
    champion:'KKR',
    Orange_Cap: 'CH Gayle',
    Purple_Cap: 'M Morkel',
    Man_of_the_Series: 'SP Narine'
  },
  {
    id: uuid(),
    season: '2013',
    venue: 'Eden Gardens, Kolkata, India',
    fixture:'MI Vs CSK',
    champion:'MI',
    Orange_Cap: 'MEK Hussey',
    Purple_Cap: 'DJ Bravo',
    Man_of_the_Series: 'SR Watson'
  },
  {
    id: uuid(),
    season: '2014',
    venue: 'M Chinnaswamy Stadium, Bangalore, India',
    fixture:'KKR Vs KXIP',
    champion:'KKR',
    Orange_Cap: 'RV Uthappa',
    Purple_Cap: 'MM Sharma',
    Man_of_the_Series: 'GJ Maxwell'
  },
  {
    id: uuid(),
    season: '2015',
    venue:'Eden Gardens, Kolkata, India',
    fixture:'MI Vs CSK',
    champion:'MI',
    Orange_Cap: 'DA Warner',
    Purple_Cap: 'DJ Bravo',
    Man_of_the_Series: 'AD Russell'
  },
  {
    id: uuid(),
    season: '2016',
    venue: 'M Chinnaswamy Stadium, Bangalore, India',
    fixture:'SRH Vs RCB',
    champion:'SRH',
    Orange_Cap: 'V Kohli',
    Purple_Cap: 'B Kumar',
    Man_of_the_Series: 'V Kohli'
  }
];
